import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { supabase } from "../config/supabaseClient";

export default function PromovareSucces() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [actualizat, setActualizat] = useState(false);

  useEffect(() => {
    const anunt_id = params.get("anunt_id");

    const marcheazaPromovat = async () => {
      if (anunt_id) {
        const promovat_pana = new Date();
        promovat_pana.setDate(promovat_pana.getDate() + 7);

        await supabase
          .from("anunturi")
          .update({
            promovat: true,
            promovat_pana: promovat_pana.toISOString(),
          })
          .eq("id", anunt_id);

        setActualizat(true);
      }
    };

    marcheazaPromovat();
    setTimeout(() => navigate("/RaporteazaAnimalutGasit"), 5000);
  }, [navigate, params]);

  return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      height: "60vh", gap: "16px", textAlign: "center"
    }}>
      <FaStar size={60} color="#f4b400" />
      <h1>Anunț promovat cu succes! ⭐</h1>
      <p>Anunțul tău apare acum primul timp de <strong>7 zile</strong>.</p>
      {actualizat && <p style={{color: "#16a34a"}}>✅ Anunț actualizat!</p>}
      <p style={{color: "#999"}}>Vei fi redirecționat în 5 secunde...</p>
    </div>
  );
}